import getStockValidation from '@pylot-data/api/operations/get-stock-validation'

export type LowStockValidationProduct = {
    sku?: string | null
}

export type LowStockValidationResult = {
    available?: string | null
    sku?: string | null
    stock?: string | null
}

export const getLowStockValidation = async (
    products: LowStockValidationProduct[]
): Promise<LowStockValidationResult[]> => {
    const items = products
        .filter((product) => product.sku)
        .map((product) => ({
            sku: product.sku,
            quantity: '1'
        }))

    if (items.length === 0) return []

    const { getValidationStock } = await getStockValidation({
        input: {
            items
        }
    })

    return getValidationStock ?? []
}
